/* src/components/explanation/explanation.component.scss */
:host {
  display: block;
}
.explanation {
  display: table;
  table-layout: initial;
  width: 100%;
  border-radius: 5px;
  border: 1px solid var(--vwui-border-color-light);
  margin-bottom: 20px;
  font-family: var(--vwui-font-family-base);
  font-weight: var(--vwui-font-weight-semibold);
}
.explanation--has-link {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1);
}
.explanation--has-link:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.explanation__content {
  display: table-cell;
  vertical-align: middle;
  width: auto;
  padding: 0.9rem 1rem;
}
.explanation__actions {
  display: none;
}
.explanation__actions--visible {
  display: table-cell;
  vertical-align: middle;
  width: 1px;
  white-space: nowrap;
  padding: 0.6rem 0.6rem 0.6rem 0;
}
.explanation__icon {
  display: inline-block;
  vertical-align: middle;
  line-height: 1;
}
.explanation__icon--alert {
  color: #FFAB01;
  margin: -0.1rem 1rem 0 0;
}
.explanation__icon--next {
  --vwui-icon--size: 0.7em;
  margin: 0 0 0 0.3rem;
}
/*# sourceMappingURL=explanation.component-5YEWPTQK.css.map */
